<div class="mat-font-headline-sm"><fa-icon icon="{{ eicon }}" class="mr-4"></fa-icon>{{ teitl }}</div>
